(function (angular) {
	'use strict';

	var annualReturnsTableObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {
			smallerTableFontSize: '<',
			priorYearReturns: '<?'
		},
		controller: [
			'DashboardPerformanceService',
			AnnualReturnsTableFunction
		],
		controllerAs: 'annualReturnsTable'
	};

	angular
		.module('investorDashboard')
		.component('annualReturnsTable', annualReturnsTableObject);

	function templateUrlFunction(STATIC_BASE_PATH) {
		return STATIC_BASE_PATH + '/static/html/investor-dashboard/annual-returns-table.html';
	}

	function AnnualReturnsTableFunction(
		DashboardPerformanceService
	) {
		var annualReturnsTable = this;

		annualReturnsTable.setActiveMobileColumn = function(column) {
			DashboardPerformanceService.setActiveMobileColumn(annualReturnsTable.priorYearReturns, column);
		};

		annualReturnsTable.toggleViewFormat = function(viewKey) {
			DashboardPerformanceService.toggleViewFormat(annualReturnsTable.priorYearReturns, viewKey);
		};

		annualReturnsTable.toggleTableSection = function(section) {
			DashboardPerformanceService.toggleTableSection(annualReturnsTable.priorYearReturns, section);
		};

		annualReturnsTable.navigateToReitPositionView = DashboardPerformanceService.navigateToReitPositionView;

		function determineDataState() {
			annualReturnsTable.loadingPerformance = angular.isUndefined(annualReturnsTable.priorYearReturns);
			annualReturnsTable.hasData = !angular.equals({}, annualReturnsTable.priorYearReturns);
		}

		annualReturnsTable.$onInit = function() {
			annualReturnsTable.performanceCategories = ['reportingNav', 'notReportingNav'];
			determineDataState();
		};

		annualReturnsTable.$onChanges = function() {
			determineDataState();
		};
	}
})(window.angular);